import React from 'react';
import { Link } from 'react-router-dom';

// Services & Helpers
import BaseService from 'services/BaseService';

// Components
import Loader from 'components/common/Loader';
import BookingsSection from 'components/instructor/BookingsSection';
import AvailabilitySelector from 'components/instructor/AvailabilitySelector';
import EditBookingModal from 'components/bookings/EditBookingModal';

//-------------------------------------------------------------------------------------------------------------------

class Deliveries extends React.Component {

    constructor(props) {
        super(props);

        this.editBookingModalRef = React.createRef();

        this.state = {
            isLoading: true
        };
    }

    componentDidMount() {
        this.load();
    }

    async load() {
        const { instructor } = this.props;
        const availability = await BaseService.callAPI('instructor/get-full-availability/' + (instructor.slug || ''));
        this.setState({
            availability,
            isLoading: false
        });
    }

    async editBooking(id) {
        await this.editBookingModalRef.current.show({
            bookingID: id,
            instructorID: this.props.instructor.id,
            status: (!!id ? undefined : 'Active')
        });
    }

    //-------------------------------------------------------------------------------------------------------------------
    //  Render
    //-------------------------------------------------------------------------------------------------------------------

    render() {
        const { instructor, isEditMode, loginInfo } = this.props;
        const { isLoading } = this.state;

        if (isLoading) {
            return (<Loader fullPage />);
        }

        return (<>
            <BookingsSection
                isEditMode={isEditMode && loginInfo.isAdmin}
                canAdd={loginInfo.isAdmin}
                className="upcoming-classes-section"
                type="future"
                title="Upcoming classes"
                emptyText="No upcoming classes"
                instructorID={instructor.id}
                onSelect={async (booking, refresh) => {
                    await this.editBooking(booking.id);
                    if (refresh) refresh();
                }}
            />

            {loginInfo.isVendorOrAdmin && this.renderAvailability()}

            <BookingsSection
                isEditMode={isEditMode && loginInfo.isAdmin}
                className="booking-history-section"
                type="past"
                title="Booking history"
                emptyText="No booking history available"
                instructorID={instructor.id}
                onSelect={async (booking, refresh) => {
                    await this.editBooking(booking.id);
                    refresh();
                }}
            />

            <EditBookingModal ref={this.editBookingModalRef} />
        </>);
    }

    renderAvailability() {
        const { instructor, loginInfo } = this.props;
        const { availability } = this.state;
        
        return (<>
            <h2>
                Availability

                {!loginInfo.isVendor &&
                    <Link to={'/availability-selector/' + instructor.slug} className="btn btn-sm">
                        <span className="fa fa-pencil-alt"></span>{' '}
                        Edit
                    </Link>
                }
            </h2>

            {availability && !!instructor.id &&
                <AvailabilitySelector
                    isScrollable
                    workingDays={instructor.workingDays}
                    availability={availability}
                    onViewBooking={this.viewBooking}
                />
            }

        </>);
    }
}

export default Deliveries;